<template>
    <div id="customer_create_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
                <div class="container-fluid xyz">
                    <div class="page-name">
                        <div class="page-title" id="customercontactHeader">Customer Needs Analysis Form</div>
                    </div>
                    <div class="admin-page-content customer-needs">
                        <section class="internal-container border-top-table-fl">
                              <form autocomplete="off" class="form-horizontal basic-form-container customer-analysis-form add-user-form-title form-custom-select" id="frmcredit">
                                  <div class="form-row row-cols-md-4 row-cols-1">
                                      <div class="col form-group">
                                          <label class="control-label require">Date</label>
                                          <div class="input-group">
                                              <date-picker placeholder="MM/DD/YYYY" id="startDate" name="leaving_date" v-model="date" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                              <label for="startDate" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                          </div>
                                          <div class="field-error">{{dateerror_msg}}</div>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label require">Needed By Date:</label>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="dropDate" name="leaving_date" v-model="neededDate" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="dropDate" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <div class="field-error">{{Ddateerror_msg}}</div>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label" for="name">Account Manager:</label>
                                        <v-select id="AccountManager" v-model="accManager" class="custom-ci-auto-search" placeholder="Select Account Manager" :options="managerArr" label="text" name="AccountManager"></v-select>
                                        <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">    
                                        <label class="control-label" for="name">Sales Management:</label>
                                        <v-select id="SalesManagement" class="custom-ci-auto-search" v-model="salesManage" placeholder="Select Sales Manager" :options="manageArr" label="text" name="SalesManagement"></v-select>
                                        <div class="field-error">{{ customererrors }}</div>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label require" for="email">Name of contact:</label>
                                        <input id="Contact" class="form-control" name="Contact" type="text">
                                        <div class="field-error">{{contacterror}}</div>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label require" for="name">Name of company:</label>
                                        <input id="Company" class="form-control" required name="Company" type="text">
                                        <div class="field-error">{{companyerror}}</div>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label require" for="email">Title:</label>
                                        <input id="Title" class="form-control" required name="Title" type="text">
                                        <div class="field-error">{{titleerror}}</div>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label">Products Hauled:</label>
                                        <textarea id="Hauled" class="form-control" size='40' rows="2" name="Hauled"></textarea>
                                        <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label" for="email"> Lanes (where company travels):</label>
                                        <textarea id="Lanes" class="form-control" rows="2" name="Lanes"></textarea>
                                        <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label require" for="email"> How far (miles/year and days/week)?:</label>
                                        <input id="Miles" class="form-control" required name="Miles" type="text">
                                        <div class="field-error">{{mileserror}}</div>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label" for="address_2">License:</label>
                                        <v-select id="License" class="custom-ci-auto-search" v-model="licence" placeholder="Select Licence Type" name="License" label='text' :options="licenceArr"></v-select>
                                        <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label require" for="address_2">Port Customer:</label>
                                        <v-select id="Port" class="custom-ci-auto-search" v-model="port" placeholder="Port Customer" :options="portArr" label="text" required name="PortYN"></v-select>
                                        <div class="field-error">{{porterror}}</div>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label" for="address_2">Onsite Maintenance?:</label>
                                        <v-select id="OnsiteYN" class="custom-ci-auto-search" v-model="onsiteMain" placeholder="Require Onsite Maintenance" :options="maintArr" label="text" required name="OnsiteYN"></v-select>
                                        <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                        <div class="example-label">
                                          <label class="control-label" for="address_2">Sic Code:</label>
                                        </div>
                                        <v-select v-model="sicCode" class="custom-ci-auto-search" placeholder="Select Sic Code" label="text" id="SicCode" :options="sicCodesArr" name="SicCode"></v-select>
                                        <div class="field-error"></div>
                                      </div>
                                  </div>
                                  <hr class="light-hr" style="border-style:dashed;"/>
                                  <h4 class="color-darkblue font-semibold">CAB/CHASSIS &amp; ENGINE</h4>
                                  <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                      <label class="control-label" for="address_2">Engine Requirements:</label>
                                      <input id="Engine" class="form-control" name="Engine" type="text">
                                      <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label" for="state">Transmission Model:</label>
                                      <input id="Transmission" class="form-control" name="Transmission" type="text">
                                      <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label require" for="address_2">Engine Type:</label>
                                      <v-select id="EngineType" class="custom-ci-auto-search" v-model="engine" placeholder="Select Engine Type" :options="engArr" label="text" required name="EngineType"></v-select>
                                      <div class="field-error">{{enginerror}}</div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label require" for="city_id">Transmission Type:</label>
                                      <v-select id="TransMenu" class="custom-ci-auto-search" v-model="transmission" placeholder="Select Transamission Type" :options="transArr" label="text" required name="TransMenu"></v-select>
                                      <div class="field-error">{{transerror}}</div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label" for="fax_no">Total Fuel Needed:</label>
                                      <input id="Fuel" class="form-control" placeholder="Gallons" name="Fuel" type="text" @keypress="isAmountCheck($event)">
                                      <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                      <div class="example-label">
                                        <label class="control-label" for="zip">DEF Tank:</label>
                                        <i class="fa fa-info-circle" aria-hidden="true" ></i>
                                      </div>
                                      <input id="DefTank" class="form-control" name="DefTank" type="text">
                                      <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label" for="invoices">Sleeper Size:</label>
                                      <input id="Sleeper" class="form-control" name="Sleeper" type="text" @keypress="isAmountCheck($event)">
                                      <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="invoices">Paint Color:</label>
                                        <input id="Paint" class="form-control" name="Paint" type="text">
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="invoices">GVW:</label>
                                      <input id="GVW" class="form-control" required name="GVW" type="text" @keypress="isAmountCheck($event)">
                                      <div class="field-error">{{gvwerror}}</div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label require" for="invoices">Make:</label>
                                      <v-select id="Make" class="custom-ci-auto-search" v-model="make" :options="manuArr" label="text" placeholder="Select Manufacturer" required name="Make"></v-select>
                                      <div class="field-error">{{makeerror}}</div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label require" for="invoices">Model:</label>
                                      <v-select id="Model" class="custom-ci-auto-search" v-model="model" :options="modelArr" label="text" placeholder="Select Model" required name="Model"></v-select>
                                      <div class="field-error">{{modelerror}}</div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label require" for="invoices">Type:</label>
                                      <v-select id="TruckType" class="custom-ci-auto-search" v-model="type" placeholder="Select Asset Type" :options="typeArr" label="text" required name="TruckType"></v-select>
                                      <div class="field-error">{{typeerror}}</div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label" for="invoices">Other:</label>
                                      <input id="OtherType" class="form-control" name="OtherType" type="text">
                                      <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                          <label class="control-label" for="invoices">PTO Make:</label>
                                        <input id="PTOMake" class="form-control" name="PTOMake" type="text">
                                        <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="invoices">PTO Model:</label>
                                      <input id="PTOModel" class="form-control" name="PTOModel" type="text">
                                      <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label" for="invoices">Other info:</label>
                                      <textarea id="OtherInfo" class=form-control cols="40" rows="1" name="OtherInfo"></textarea>
                                      <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label" for="invoices">Wheels:</label>
                                      <v-select id="WheelsMenu" v-model="wheel" class="custom-ci-auto-search" placeholder="Wheels" :options="wheelArr" label="text" name="WheelsMenu"></v-select>
                                      <div class="field-error"></div>
                                    </div>
                                    <div class="col form-group">
                                      <label class="control-label" for="invoices">Collision Mitigation:</label>
                                      <div class="custom-checkbox">
                                          <label for="active_brake_assist" class="checkbox-custom"> Active Brake Assist
                                          <input type="checkbox"  v-model="active_brake_assist" value="1" id="active_brake_assist" name="active_brake_assist"> 
                                          <span class="checkmark"></span></label>
                                      </div>

                                      <div class="custom-checkbox">
                                          <label for="lane_departure_warning" class="checkbox-custom"> Lane Departure Warning
                                          <input type="checkbox"  v-model="lane_departure_warning" value="1" id="lane_departure_warning" name="lane_departure_warning"> 
                                          <span class="checkmark"></span></label>
                                      </div>

                                      <div class="custom-checkbox">
                                          <label for="roll_over_stability" class="checkbox-custom"> Roll-over Stability
                                          <input type="checkbox"  v-model="roll_over_stability" value="1" id="roll_over_stability" name="roll_over_stability"> 
                                          <span class="checkmark"></span></label>
                                      </div>

                                      <div class="custom-checkbox">
                                          <label for="side_object_detection" class="checkbox-custom"> Side Object Detection
                                          <input type="checkbox"  v-model="side_object_detection" value="1" id="side_object_detection" name="side_object_detection"> 
                                          <span class="checkmark"></span></label>
                                      </div>
                                      <div class="field-error"></div>
                                    </div>
                                  </div>
                                  <hr class="light-hr" style="border-style:dashed;"/>
                                  <h4 class="color-darkblue font-semibold">BODY</h4>
                                  <div class="form-row row-cols-md-4 row-cols-1">
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Length:</label>
                                          <input id="Length" class="form-control" name="Length" type="text" @keypress="isAmountCheck($event)">
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label" for="invoices">Width:</label>
                                        <input id="Width" class="form-control" size="10" name="Width" type="text" @keypress="isAmountCheck($event)">
                                        <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Height:</label>
                                          <input id="Height" class="form-control" size="10" name="Height" type="text" @keypress="isAmountCheck($event)">
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">E-Track?:</label>
                                          <v-select id="ETrackYN" v-model="track" placeholder="E-Track" label="text" :options="maintArr" name="ETrackYN"></v-select>
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">How may rows &amp; height:</label>
                                          <input id="ETrack" class="form-control" size="20" name="ETrack" type="text" @keypress="isAmountCheck($event)">
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Side Door?:</label>
                                          <v-select id="SideDoorYN" v-model="sideDoor" placeholder="Side Door" label="text" :options="maintArr" name="SideDoorYN"></v-select>
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Location:</label>
                                          <input id="DoorLocation" class="form-control" size="20" name="DoorLocation" type="text">
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Liftgate?:</label>
                                          <v-select id="LiftgateYN" v-model="liftgate" placeholder="Lift Gate" label="text" :options="maintArr" name="LiftgateYN"></v-select>
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Type:</label>
                                          <v-select id="LiftgateType" v-model="liftgateType" label="text" placeholder="Select Lift Gate Type" :options="gatetypeArr" name="LiftgateType"></v-select>
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Size:</label>
                                          <input id="LiftgateSize" class="form-control" size="20" name="LiftgateSize" type="text" @keypress="isAmountCheck($event)">
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Ramp?:</label>
                                          <v-select id="RampYN" v-model="ramp" placeholder="Ramp" label="text" :options="maintArr" name="RampYN"></v-select>
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Capacity:</label>
                                          <input id="RampCapacity" class="form-control" size="20" name="RampCapacity" type="text" @keypress="isAmountCheck($event)">
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Floor Type:</label>
                                          <input id="FloorType" class="form-control" size="25" name="FloorType" type="text">
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Other info:</label>
                                          <textarea id="OtherInfo2" class="form-control" rows="1" name="OtherInfo2"></textarea>
                                          <div class="field-error"></div>
                                      </div>
                                  </div>
                                   <hr class="light-hr" style="border-style:dashed;"/>
                                   <h4 class="color-darkblue font-semibold">REEFER</h4>
                                  <div class="form-row row-cols-md-4 row-cols-1">
                                      <div class="col form-group">
                                        <label class="control-label" for="invoices">Average Temperature:</label>
                                        <input id="ReeferTemp" class="form-control" name="ReeferTemp" type="text">
                                        <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label" for="invoices">Manufacturer:</label>
                                        <v-select id="ReeferType" v-model="manufacturer" placeholder="Select Manufacturer" label="text" :options="manufactArr" name="ReeferType"></v-select>
                                        <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                        <label class="control-label" for="invoices"># of stops/day:</label>
                                        <input id="StopsDay" class="form-control" size="10" name="StopsDay" type="text"  @keypress="isAmountCheck($event)">
                                        <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices"> # of door openings:</label>
                                          <input id="DoorOpenings" class="form-control" size="10" name="DoorOpenings" type="text"  @keypress="isAmountCheck($event)">
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Est. Hours/Day:</label>
                                          <input id="HoursDay" class="form-control" size="10" name="HoursDay" type="text"  @keypress="isAmountCheck($event)">
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Est. Hours/Week:</label>
                                          <input id="HoursWeek" class="form-control" size="10" name="HoursWeek" type="text"  @keypress="isAmountCheck($event)">
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Est. Hours/Month:</label>
                                          <input id="HoursMonth" class="form-control" size="10" name="HoursMonth" type="text"  @keypress="isAmountCheck($event)">
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Est. Hours/Year:</label>
                                          <input id="HoursYear" class="form-control" size="10" name="HoursYear" type="text"  @keypress="isAmountCheck($event)">
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Multi-Compartment?:</label>
                                          <v-select id="MultiYN" v-model="compart" placeholder="Choose.." label="text" :options="maintArr" name="MultiYN"></v-select>
                                          <div class="field-error"></div>
                                      </div>
                                      <div class="col form-group">
                                          <label class="control-label" for="invoices">Other info:</label>
                                          <textarea id="OtherInfo3" class="form-control" rows="2" name="OtherInfo3"></textarea>
                                      </div>
                                  </div>
                                  <div class="btn-groups mt-4">
                                      <button type="button" id="submitBtn" name="submit" v-on:click="ValidateForm(this)" class="btn btn-primary" > <i class="fp-submit"> </i> Submit</button>
                                  </div>
                              </form>
                        </section>        
                    </div>
                </div>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import { commonMixins } from "../mixins/commonMixins";


export default {
  name: "CustomerContactCreate",
  metaInfo() {
       return {
           title: "Customer Needs Analysis | " +process.env.COPYRIGHT_NAME
       }
  },
  mixins: [commonMixins],
  data() {
    return {
      sicCode: null,
      ramp: null,
      date: "",
      neededDate: "",
      sitekey: "6LfolpwUAAAAAPCadbtvLZa0iCvLPKfLwwKnm1LA",
      sicCodesArr: [],
      licence: null,
      licenceArr: [
        {
          text: "CA Only",
          value: "CA Only"
        },
        {
          text: "AZ Only",
          value: "CA Only"
        },
        {
          text: "NV Only",
          value: "NV Only"
        },
        {
          text: "IRP",
          value: "IRP"
        },
        {
          text: "Customer",
          value: "Customer"
        }
      ],
      portArr: [
        {
          text: "Yes",
          value: "Yes"
        },
        {
          text: "No",
          value: "No"
        }
      ],
      port: null,
      onsiteMain: null,
      maintArr: [
        {
          text: "Yes",
          value: "Yes"
        },
        {
          text: "No",
          value: "No"
        }
      ],
      engArr: [
        {
          text: "B67",
          value: "B67"
        },
        {
          text: "ISB",
          value: "ISB"
        },
        {
          text: "DD5",
          value: "DD5"
        },
        {
          text: "DD8",
          value: "DD8"
        },
        {
          text: "DD13",
          value: "DD13"
        },
        {
          text: "DD15",
          value: "DD15"
        }
      ],
      engine: null,
      transmission: null,
      compart: null,
      transArr: [
        {
          text: "Manual",
          value: "Manual"
        },
        {
          text: "Auto",
          value: "Auto"
        }
      ],
      manuArr: [
        {
          text: "Freightliner",
          value: "Freightliner"
        },
        {
          text: "Western Star",
          value: "Western Star"
        },
        {
          text: "Hino",
          value: "Hino"
        },
        {
          text: "Isuzu",
          value: "Isuzu"
        },
        {
          text: "Ford",
          value: "Ford"
        }
      ],
      manufacturer: null,
      modelArr: [
        {
          text: "M2-106",
          value: "M2-106"
        },
        {
          text: "M2-112",
          value: "M2-112"
        },
        {
          text: "CA 116",
          value: "CA 116"
        },
        {
          text: "CA 126",
          value: "CA 126"
        }
      ],
      model: null,
      type: null,
      typeArr: [],
      wheel: null,
      wheelArr: [
        {
          text: "Aluminum",
          value: "Aluminum"
        },
        {
          text: "Steel",
          value: "Steel"
        }
      ],
      liftgateType: null,
      gatetypeArr: [
        {
          text: "Truck",
          value: "Truck"
        },
        {
          text: "Rail",
          value: "Rail"
        }
      ],
      liftgate: null,
      sideDoor: null,
      track: null,
      manufactArr: [
        {
          text: "ThermoKing",
          value: "ThermoKing"
        },
        {
          text: "Carrier",
          value: "Carrier"
        }
      ],
      make: null,
      managerArr: [
        {
          text: "Glen Poyser",
          value: "Glen Poyser"
        },
        {
          text: "Brad Fritz",
          value: "Brad Fritz"
        },
        {
          text: "Randy MacDonald",
          value: "Randy MacDonald"
        },
        {
          text: "Josh Porter",
          value: "Josh Porter"
        },
        {
          text: "Kris Gregory",
          value: "Kris Gregory"
        },
        {
          text: "Tony Wills",
          value: "Tony Wills"
        },
        {
          text: "James Spear",
          value: "James Spear"
        },
        {
          text: "Todd Erickson",
          value: "Todd Erickson"
        },
        {
          text: "Mike Reid",
          value: "Mike Reid"
        },
        {
          text: "Daniel Rabago",
          value: "Daniel Rabago"
        }
      ],
      accManager: null,
      salesManage: null,
      manageArr: [
        {
          text: "Thomas Puppe",
          value: "Thomas Puppe"
        },
        {
          text: "Andy Lewis",
          value: "Andy Lewis"
        }
      ],
      companyerror: "",
      contacterror: "",
      gvwerror: "",
      titleerror: "",
      mileserror: "",
      enginerror: "",
      transerror: "",
      makeerror: "",
      typeerror: "",
      porterror: "",
      modelerror: "",
      googleResponse: "",
      captchaerror: "",
      dateerror_msg: "",
      Ddateerror_msg: "",
      permissions: [],
      optionsDate: {
            format: 'MM/DD/YYYY',
            useCurrent: false,
        },
      collisonMitigation:[],
      loading:false,
      customererrors:"",
      active_brake_assist:"",
      lane_departure_warning:"",
      roll_over_stability:"",
      side_object_detection:""
    };
  },
  watch: {
    permissions: function(permission) {
      var self = this;
      permission.forEach(function(permissions) {
        if (permissions.name == "add_customer_need") {
          self.cantAccess = true;
        }
      });
      if (self.cantAccess == "") {
        self.cantAccess = false;
      }
    }
  },
  mounted: function() {
    // this.$nextTick(function() {
    //   grecaptcha.render("recaptcha-main");
    // });

    var userObj = localStorage.getItem("user_obj");
    var role = null;

    //if user logged in than remove login button and registration button
    if (userObj != null) {
      var userJson = JSON.parse(userObj);
      if (userJson.roles.length > 0) {
        role = userJson.roles[0].name;
      }

      // if (role != "SuperAdmin") {
      //     this.$set(this.columns[4], 'hidden', true);
      // } else {
      //     this.$set(this.columns[4], 'hidden', false);
      // }
    //   EventBus.$emit("logged-in", false, userJson["contact"], role);
    }
    if (role == "customer") {
      this.$router.push("/");
    }
    this.getTruckType();
    this.getSidCodes();
    setTimeout(function() {
      $("#startDate").mousedown(function() {
        console.log("click recieved");
        if (
          $("#startDate")
            .closest("div")
            .find(".vdatetime-popup")
            .attr("style") == "display: none;"
        ) {
          $("#startDate")
            .closest("div")
            .find(".vdatetime-popup")
            .show();
        } else {
          $("#startDate")
            .closest("div")
            .find(".vdatetime-popup")
            .hide();
        }
        if (
          $("#dropDate")
            .closest("div")
            .find(".vdatetime-popup")
            .attr("style") != "display: none;"
        ) {
          // $(".vdatetime-popup").toggle();
          $("#dropDate")
            .closest("div")
            .find(".vdatetime-popup")
            .hide();
        }
        console.log(
          $("#startDate")
            .closest("div")
            .find(".vdatetime-popup")
            .attr("style")
        );
      });
      $("#dropDate").mousedown(function() {
        if (
          $("#startDate")
            .closest("div")
            .find(".vdatetime-popup")
            .attr("style") != "display: none;"
        ) {
          // $(".vdatetime-popup").toggle();
          $("#startDate")
            .closest("div")
            .find(".vdatetime-popup")
            .hide();
        }
        if (
          $("#dropDate")
            .closest("div")
            .find(".vdatetime-popup")
            .attr("style") == "display: none;"
        ) {
          $("#dropDate")
            .closest("div")
            .find(".vdatetime-popup")
            .show();
        } else {
          $("#dropDate")
            .closest("div")
            .find(".vdatetime-popup")
            .hide();
        }
      });
    }, 100);
    this.getPermissions();
  },
  methods: {
    getTruckType: function() {
      var self = this;
      $.ajax({
        url:
          process.env.ROOT_API + "/assettype/search",
        type: "GET",
        crossDomain: true,
        dataType: "json",
        headers: this.ajxHeaders,
        data: { flag: "dealership" },
        success: function(data) {
          //console.log(data.content[0]["id"]);
          if (data) {
              console.log(data);
            self.typeArr = data;
            console.log(self.truckSelect);
            // self.dealership.value = data.content.value;
            // self.dealership.deal = data.content.text;
          }
        },
        error: function(jqXHR, exception) {
            self.generateStatusCodeMessage(jqXHR, true, 'cust-need-asset-type-search')
        }
      });
    },
    getSidCodes: function() {
      var self = this;
      $.ajax({
        url: process.env.ROOT_API + "/get_sic_codes",
        type: "GET",
        success: function(data) {
          self.sicCodesArr = data.content;
        },
        error: function() {
        //   alert("An error occurred while processing the request.");
            self.generateStatusCodeMessage(jqXHR, true, 'cust-need-get-sic-code')
        }
      });
    },
    ValidateForm: function() {
      var self = this;
          
      // self.googleResponse = grecaptcha.getResponse();
        
      self.captchaerror = "";
      self.companyerror = "";
      self.contacterror = "";
      self.titleerror = "";
      self.mileserror = "";
      self.mileserror = "";
      self.porterror = "";
      self.enginerror = "";
      self.gvwerror = "";
      self.transerror = "";
      self.makeerror = "";
      self.modelerror = "";
      self.dateerror_msg = "";
      self.Ddateerror_msg = "";
      self.typeerror = "";

      // self.date = moment(self.date).tz('PST8PDT').format("MM/DD/YYYY hh:mm A");
      // this.pickup_time = moment(self.PickDate).format("hh:mm A");
      // self.neededDate = moment(self.neededDate).tz('PST8PDT').format("MM/DD/YYYY hh:mm A");
      // this.dropoff_time = moment(self.DropDate).format("hh:mm A");
      var validate = true;
      var company = $("#Company").val();
      var contact = $("#Contact").val();
      var title = $("#Title").val();
      var miles = $("#Miles").val();
      var gvw = $("#GVW").val();

        // if(!self.googleResponse){
        //     self.captchaerror = 'Captcha Required';
        //     validate = false;
        // }
      if (self.date == "") {
          self.dateerror_msg = "Date is required";
          validate = false;
      }
      if (self.neededDate == "") {
          self.Ddateerror_msg = "Needed date is required";
          validate = false;
      }
      if (!company || company == "") {
        self.companyerror = "Company name is required";
        validate = false;
      }
      if (!contact || contact == "") {
        self.contacterror = "Contact name is required";
        validate = false;
      }
      if (!title || title == "") {
        self.titleerror = "Title is required";
        validate = false;
      }
      if (!gvw || gvw == "") {
        self.gvwerror = "GVW is required";
        validate = false;
      }
      if (!miles || miles == "") {
        self.mileserror = "Miles is required";
        validate = false;
      }
      
      if (self.port == null) {
        self.porterror = "Port customer is required";
        validate = false;
      }
      if (!self.port.value || self.port.value == "") {
        self.porterror = "Port customer is required";
        validate = false;
      }
      if (self.engine == null) {
        self.enginerror = "Engine type is required";
        validate = false;
      }
      if (!self.engine.value || self.engine.value == "") {
        self.enginerror = "Engine type is required";
        validate = false;
      }
      if (self.transmission == null) {
        self.transerror = "Transmission is required";
        validate = false;
      }
      if (!self.transmission.value || self.transmission.value == "") {
        self.transerror = "Transmission is required";
        validate = false;
      }
      if (self.make == null) {
        self.makeerror = "Make is required";
        validate = false;
      }
      if (!self.make.value || self.make.value == "") {
        self.makeerror = "Make is required";
        validate = false;
      }
      if (self.model == null) {
        self.modelerror = "Model is required";
        validate = false;
      }
      if (!self.model.value || self.model.value == "") {
        self.modelerror = "Model is required";
        validate = false;
      }
      if (self.type == null) {
        self.typeerror = "Type is required";
        validate = false;
      }
      if (!self.type.value || self.type.value == "") {
        self.typeerror = "Type is required";
        validate = false;
      }

      if (validate == false) {
        self.errorValidationFocus();
        return;
      }

      // var strUrl = 'https://www.velocityvehiclegroup.com/vtrl-customer-needs-form';
      
      var fields = $("#frmcredit").serializeArray();
        if(self.sicCode == null){
            fields.push({name: "sicCode", value: ""});
        }else{
            fields.push({name: "sicCode", value: self.sicCode.text});
        }

        if(self.wheel == null){
            fields.push({name: "wheel", value: ""});
        }else{
            fields.push({ name: "wheel", value: self.wheel.text });
        }
        if(self.track == null){
            fields.push({name: "track", value: ""});
        }else{
            fields.push({ name: "track", value: self.track.text });
        }
        if(self.liftgate == null){
            fields.push({name: "liftgate", value: ""});
        }else{
            fields.push({ name: "liftgate", value: self.liftgate.text });
        }
        if(self.ramp == null){
            fields.push({name: "ramp", value: ""});
        }else{
            fields.push({ name: "ramp", value: self.ramp.text });
        }
        if(self.manufacturer == null){
            fields.push({name: "manufacturer", value: ""});
        }else{
            fields.push({ name: "manufacturer", value: self.manufacturer.text });
        }
        if(self.compart == null){
            fields.push({name: "compart", value: ""});
        }else{
            fields.push({ name: "compart", value: self.compart.text });
        }
        if(self.accManager == null){
            fields.push({name: "manager", value: ""});
        }else{
            fields.push({ name: "manager", value: self.accManager.text });
        }
        if(self.salesManage == null){
            fields.push({name: "salemanage", value: ""});
        }else{
            fields.push({ name: "salemanage", value: self.salesManage.text });
        }
        if(self.licence == null){
            fields.push({name: "licence", value: ""});
        }else{
            fields.push({ name: "licence", value: self.licence.text });
        }
         if(self.onsiteMain == null){
            fields.push({name: "maintenance", value: ""});
        }else{
             fields.push({ name: "maintenance", value: self.onsiteMain.text });
        }
        if(self.date == null){
            fields.push({name: "date", value: ""});
        }else{
            fields.push({ name: "date", value: self.date });
        }
        if(self.neededDate == null){
            fields.push({name: "neededDate", value: ""});
        }else{
            fields.push({ name: "neededDate", value: self.neededDate });
        }
        if(self.collisonMitigation == null){
            fields.push({name: "collisonMitigation", value: ""});
        }else{
            fields.push({ name: "collisonMitigation", value: self.collisonMitigation });
        }
        if(self.sideDoor == null){
            fields.push({name: "sideDoor", value: ""});
        }else{
            fields.push({ name: "sideDoor", value: self.sideDoor.text });
        }
        if(self.liftgateType == null){
            fields.push({name: "liftgateType", value: ""});
        }else{
            fields.push({ name: "liftgateType", value: self.liftgateType.text });
        }

//        fields.push({ name: "sicCode", value: self.sicCode.text });
      fields.push({ name: "port", value: self.port.text });
      fields.push({ name: "engine", value: self.engine.text });
      fields.push({ name: "transmission", value: self.transmission.text });
      fields.push({ name: "make", value: self.make.text });
      fields.push({ name: "model", value: self.model.text });
      fields.push({ name: "type", value: self.type.text });

      $("#submitBtn").text('Sending...');
      $("#submitBtn").prop('disabled',true);

      $.ajax({
        url:
          process.env.ROOT_API +
          "/send_customer_analysis_data",
        type: "POST",
        data: fields,
        success: function(data) {
          $("#submitBtn").text('Submit');
          $("#submitBtn").prop('disabled',false);
          alert("Mail has been sent successfully.");

          if ( self.port.text ) {
            self.port = null;
          }
          if ( self.engine.text ) {
            self.engine = null;
          }
          if ( self.transmission.text ) {
            self.transmission = null;
          }
          if ( self.make.text ) {
            self.make = null;
          }
          if ( self.model.text ) {
            self.model = null;
          }
          if ( self.type.text ) {
            self.type = null;
          }
          if ( self.wheel.text ) {
            self.wheel = null;
          }
          if ( self.track.text ) {
            self.track = null;
          }
          if ( self.sideDoor.text ) {
            self.sideDoor =null;
          }
          if ( self.liftgate.text ) {
            self.liftgate = null;
          }
          if ( self.liftgateType.text ) {
            self.liftgateType = null;
          }
          if ( self.ramp.text ) {
            self.ramp = null;
          }
          if ( self.manufacturer.text ) {
            self.manufacturer = null;
          }
          if ( self.compart.text ) {
            self.compart = null;
          }
          if ( self.accManager.text ) {
            self.accManager = null;
          }
          if ( self.licence.text ) {
            self.licence = null;
          }
          if ( self.onsiteMain.text ) {
            self.onsiteMain = null;
          }
          if ( self.date.text ) {
            self.date = "";
          }
          if ( self.neededDate.text ) {
            self.neededDate = "";
          }
          if ( self.collisonMitigation.length > 0 ) {
            self.collisonMitigation = [];
          }

          $("#frmcredit")[0].reset();
        },
        error: function() {
          alert("An error occurred while processing the request.");
            self.generateStatusCodeMessage(jqXHR, true, 'cust-need-send-data')
        }
      });
    }
  }
};
</script>








// WEBPACK FOOTER //
// src/components/CustomerNeeds.vue